import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-8"
}
const _hoisted_2 = { class: "bg-gray-800 rounded-lg p-6 shadow-lg" }
const _hoisted_3 = { class: "flex flex-col md:flex-row md:items-center" }
const _hoisted_4 = { class: "flex-shrink-0 mb-4 md:mb-0 md:mr-6" }
const _hoisted_5 = { class: "bg-gray-700 rounded-full w-24 h-24 flex items-center justify-center text-4xl font-bold text-blue-400 shadow-md relative" }
const _hoisted_6 = {
  key: 0,
  class: "absolute -top-2 -right-2 bg-blue-500 text-white text-xs font-bold px-2 py-1 rounded-full"
}
const _hoisted_7 = { class: "flex-grow" }
const _hoisted_8 = { class: "flex items-center mb-2" }
const _hoisted_9 = { class: "text-3xl font-bold text-blue-400" }
const _hoisted_10 = {
  key: 0,
  class: "ml-3 bg-blue-900 text-blue-200 px-2 py-1 rounded text-sm"
}
const _hoisted_11 = { class: "flex flex-wrap items-center gap-4 mb-4" }
const _hoisted_12 = { class: "flex items-center text-gray-300" }
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = { class: "text-green-400 font-medium mr-1" }
const _hoisted_15 = { class: "text-red-400 font-medium mr-1" }
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = { class: "text-blue-400 font-medium" }
const _hoisted_18 = { class: "mt-2 flex gap-2" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "animate-spin h-4 w-4 mr-2 border-t-2 border-b-2 border-blue-400 rounded-full"
}
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.user?.username?.charAt(0).toUpperCase() || '?') + " ", 1),
                (_ctx.isCurrentUserProfile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Vi "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.user?.username || 'Korisnik'), 1),
                (_ctx.isCurrentUserProfile)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Vaš profil "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[2] || (_cache[2] = _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "h-5 w-5 mr-2 text-green-500",
                    viewBox: "0 0 20 20",
                    fill: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      d: "M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z",
                      "clip-rule": "evenodd"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.user.city), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, "+" + _toDisplayString(_ctx.user.positiveRatings), 1),
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-gray-400 mr-4" }, "pozitivnih", -1)),
                  _createElementVNode("span", _hoisted_15, "-" + _toDisplayString(_ctx.user.negativeRatings), 1),
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-gray-400" }, "negativnih", -1))
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[5] || (_cache[5] = _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "h-5 w-5 mr-2 text-blue-400",
                    viewBox: "0 0 20 20",
                    fill: "currentColor"
                  }, [
                    _createElementVNode("path", { d: "M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" })
                  ], -1)),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.followersCount), 1),
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-gray-400 ml-1" }, "pratilaca", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                (!_ctx.isCurrentUserProfile)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleToggleFollow && _ctx.handleToggleFollow(...args))),
                      class: "flex items-center bg-gray-700 hover:bg-gray-600 text-white py-2 px-4 rounded-md font-medium transition-colors border border-gray-600 hover:border-blue-400 shadow-md",
                      disabled: _ctx.isLoading
                    }, [
                      (_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20))
                        : (_openBlock(), _createElementBlock("svg", {
                            key: 1,
                            xmlns: "http://www.w3.org/2000/svg",
                            class: _normalizeClass(["h-4 w-4 mr-2", {
                  'text-blue-500': _ctx.following,
                  'text-gray-400': !_ctx.following,
                }]),
                            viewBox: "0 0 20 20",
                            fill: "currentColor"
                          }, _cache[7] || (_cache[7] = [
                            _createElementVNode("path", { d: "M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z" }, null, -1)
                          ]), 2)),
                      (_ctx.following)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Pratite"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_22, "Zaprati"))
                    ], 8, _hoisted_19))
                  : _createCommentVNode("", true),
                (_ctx.isCurrentUserProfile)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/account'))),
                      class: "flex items-center bg-blue-600 hover:bg-blue-500 text-white py-2 px-4 rounded-md font-medium transition-colors shadow-md"
                    }, _cache[8] || (_cache[8] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-4 w-4 mr-2",
                        viewBox: "0 0 20 20",
                        fill: "currentColor"
                      }, [
                        _createElementVNode("path", { d: "M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" })
                      ], -1),
                      _createElementVNode("span", null, "Pogledaj profil", -1)
                    ])))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}